import React from 'react';
import '../../styles/components/confirm-modal.scss';
import { Loader2 } from 'lucide-react';
import { CustomModal } from './CustomModal';

export class ConfirmModal extends React.Component {
  render() {
    const {
      show,
      onClose,
      title = 'Confirm',
      titleIcon,
      message = 'Are you sure?',
      onConfirm,
      confirmText = 'Confirm',
      cancelText,
      children,
      loading,
      closeBtn = false,
    } = this.props;

    return (
      <CustomModal
        isOpen={show}
        header={title}
        headerIcon={titleIcon}
        modalClassName="modal-l2-sm"
        closeBtn={closeBtn}
        footer={
          <>
            {cancelText && (
              <button className="modal-btn btn-cancel" onClick={onClose}>
                {cancelText}
              </button>
            )}
            {onConfirm && (
              <button className="modal-btn btn-confirm" onClick={onConfirm} disabled={loading}>
                {loading ? (
                  <span
                    style={{
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <Loader2 className="animate-spin" size={16} /> {confirmText}
                  </span>
                ) : (
                  confirmText
                )}
              </button>
            )}
          </>
        }
        onClose={onClose}
      >
        {children ? children : <p className="modal-message">{message}</p>}
      </CustomModal>
    );
  }
}
